import React from 'react';

import SiteLayout from 'Config/SiteLayout';

export default class SettingsLayout extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const Component = SiteLayout.site_layout_files.settings_layout;
        
        return (<Component {...this.props} />);
    };
}
